<template>
    <div class="sprite-map" style="display: none">
        <div v-for="(sprite, index) in sprites" :key="index" v-html="sprite"></div>
    </div>
</template>

<script>
    export default {
        name: "SpriteMap",
        data() {
            return {
                sprites: [
                    require("!!html-loader!@/assets/icons/Icons.svg"),
                ],
            }
        },
    }
</script>

<style scoped>
</style>
